import WeekSubtitle from './week_subtitle'
import Day from './day'

const Week = ({ weekStart, days }) => (
  <div>
    <WeekSubtitle weekStart={weekStart} />
    {days.map((day) => <Day key={day.date} day={day} />)}
  </div>
)

export default Week
